// extracted by mini-css-extract-plugin
export default {"container":"PlansDisclaimerSliceContainer_container__LRHY-"};